const tagSelectorLocale = {
  placeholder: "选择标签...",
  searchPlaceholder: "搜索标签...",
  noOptionsAvailable: "暂无选项"
};
export {
  tagSelectorLocale
};
//# sourceMappingURL=zh_CN.js.map
